import { GenerationSaleSubKind } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'
import i18next from 'i18next'

/**
 * 発電販売計画マスタの計画区分 (通常電源 / FIT 特例電源) フィルタ選択肢。
 * デフォルトは通常電源 (AC-03)。FIP は master では invalid (entity constructor
 * が reject する) ため候補に含めない (generation-sales-plan-category 設計書)。
 */
export const PLAN_CATEGORY_OPTIONS: GenerationSaleSubKind[] = [
  GenerationSaleSubKind.NORMAL,
  GenerationSaleSubKind.FIT,
]

/**
 * GenerationSaleSubKind → 日本語ラベル (F1 純関数)。
 * CSV エクスポート列 (AC-07)・一覧の計画区分列・削除確認ダイアログの文言 (AC-08)・
 * 作成/編集モーダルの disabled 表示 (AC-05 / AC-06) が全てこの関数を経由する。
 */
export function planCategoryLabel(value: GenerationSaleSubKind): string {
  const t = i18next.t.bind(i18next)
  switch (value) {
    case GenerationSaleSubKind.NORMAL:
      return t(
        'page:adminOcctoMaster.generationSalesPlanMaster.planCategory.normal',
      )
    case GenerationSaleSubKind.FIT:
      return t(
        'page:adminOcctoMaster.generationSalesPlanMaster.planCategory.fit',
      )
    default:
      return ''
  }
}
